import { RequirablePropertyInputHomeCurrencyV2 } from '../../input/PropertyInputGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputCurrencyShimV2 = props => {
  // no `resolverType` needed; the shim ensures that reference resolvers are
  // provided (for use by ResolverReferences inside the leaf input)
  return /*#__PURE__*/_jsx(RequirablePropertyInputHomeCurrencyV2, Object.assign({}, props));
};
export default PropertyInputCurrencyShimV2;